import React from 'react';

import LinkButton from '../common/LinkButton';
import ClosableWarning from '../common/ClosableWarning';
import { US_WEST_LINK, AWS_EU_LINK } from '../../constants/links';

const USWestWarning = () => {
  return (
    <ClosableWarning>
      <div style={{ fontSize: '0.85rem' }}>
        <b>WARNING: Landsat/MODIS/DEM/US West BYOC layers</b>
        <p>
          Layers that use Landsat, MODIS, Mapzen DEM or BYOC with S3 bucket in AWS US West are
          processed on different infrastructure, which require:
          <br />
          -The use of <LinkButton>{US_WEST_LINK}</LinkButton> end-point instead of{' '}
          <LinkButton>{AWS_EU_LINK}</LinkButton> for these layers.
          <br />
          -Sentinel layers should not be mixed with Landsat/MODIS/DEM/US West BYOC layers in the
          same configuration instance.
        </p>
        <p>
          In the next few weeks we will migrate these two end-points, but until then please take the
          above into consideration.
        </p>
      </div>
    </ClosableWarning>
  );
};

export default React.memo(USWestWarning);
